import { BaseUrl } from "../config/api";
import { toHttps } from "../utils/imageUtils";

export const getAccessoriesByProduct = async (productId) => {
  const res = await fetch(`${BaseUrl}/accessories/product/${productId}`);

  if (!res.ok) {
    throw new Error("Failed to fetch accessories");
  }

  const data = await res.json();

  return data.map((acc) => ({
    id: acc._id,
    _id: acc._id,
    name: acc.accessoryName,
    price: `$${Number(acc.sellingPrice).toFixed(2)}`,
    images: acc.images?.length
      ? acc.images.map(toHttps)
      : [],
    discount:
      acc.actualPrice && acc.sellingPrice
        ? Math.round(
            ((acc.actualPrice - acc.sellingPrice) / acc.actualPrice) * 100
          )
        : 0,
  }));
};
